// axios
import axios from 'axios'
import getBaseUrl from "./getBaseUrl";
import inIframe from "@/helpers/inIframe";

const baseURL = getBaseUrl() + '/api';

const http = axios.create({
    baseURL,
    headers: {
        'x-Authorization': inIframe() ? null : localStorage.getItem('access_token')
    }
    // You can add your headers here
})


http.interceptors.request.use(
    function (config) {
        const token = inIframe() ? null : localStorage.getItem('access_token');
        config.headers['x-Authorization'] = token;
//        config.headers.VkToken = 'QSW3fppqkG5CQRlUfUhpyOfJS8dEOIuxNevqzIQX3JLm7Sl9K9';
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);


export default http;